import React, { useState, useEffect } from 'react';

const ExpandableImage = ({ src, alt, className }) => {
    const [open, setOpen] = useState(false);

    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    // escape key event listener
    const handleKeyDown = (event) => {
        if (event.key === 'Escape') {
            handleClose();
        }
    };
    // add event listener when the modal is open
    useEffect(() => {
        if (open) {
            window.addEventListener('keydown', handleKeyDown);
        } else {
            window.removeEventListener('keydown', handleKeyDown);
        }
        // cleanup function
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [open]);

    return (
        <>
            <img
                src={src}
                alt={alt}
                className={className}
                onClick={handleOpen}
                style={{ cursor: 'pointer' }}
            />
            {open && (
                <div
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: 'rgba(0, 0, 0, 0.7)',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        zIndex: 1000
                    }}
                    onClick={handleClose}
                >
                    <div
                        style={{
                            position: 'relative',
                            maxWidth: '90%',
                            minWidth: '50%',
                            maxHeight: '90%',
                            backgroundColor: 'var(--neutral-200)',
                            overflow: 'hidden',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            padding: '20px',
                            borderRadius: '8px'
                        }}>
                        <img
                            src={src}
                            alt={alt}
                            style={{
                                maxHeight: '80vh',
                                maxWidth: '70vw',
                                objectFit: 'contain'
                            }}
                        />
                    </div>
                </div>
            )}
        </>
    );
};

export default ExpandableImage;